import { cn } from "@/lib/utils";
import React from "react";

type SelectableCardProps = Omit<
  React.HTMLAttributes<HTMLButtonElement>,
  "disabled"
> & {
  selected?: boolean;
  disabled?: boolean;
};

export const SelectableCard = ({
  selected,
  disabled,
  className,
  children,
  onKeyDown,
  ...props
}: SelectableCardProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    onKeyDown?.(e);
    if (disabled) return;
    // Activate on Enter/Space like a native button, reusing the onClick handler.
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      e.currentTarget.click();
    }
  };

  return (
    <li>
      <button
        className={cn(
          "relative flex w-40 min-w-40 cursor-pointer flex-col items-center gap-4 p-4",
          "border-foreground-2 h-full rounded-2xl border-2 bg-white",
          "transition-[translate,shadow] duration-150",
          "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none",
          !disabled &&
            "hover:translate-x-[-2px] hover:translate-y-[-2px] hover:shadow-md",
          selected && "bg-background-4",
          disabled && "cursor-default",
          className,
        )}
        tabIndex={disabled ? -1 : 0}
        aria-pressed={selected}
        aria-disabled={disabled}
        onKeyDown={handleKeyDown}
        {...props}
      >
        {children}
      </button>
    </li>
  );
};
